<template>
  <div>
    <el-dialog
      style="position:absolute;left:0px;top:20%;z-index:-1;"
      type="border-card"
      :visible.sync="dialogFormVisible"
      append-to-body
      width="30%"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="内嵌视频" name="second">
          <el-input
            type="textarea"
            show-word-limit
            placeholder="iframe"
            v-model="pyhi"
          ></el-input>
          <el-input
            size="mini"
            show-word-limit
            placeholder="视频宽"
            v-model="pyhiw"
          ></el-input>
          <el-input
            size="mini"
            show-word-limit
            placeholder="视频高"
            v-model="pyhih"
          ></el-input>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="iframepyhi">确 定</el-button>
        </el-tab-pane>
        <!--                @onUpLoad="onUpLoad"-->
        <el-tab-pane label="上传视频" name="first">
          <el-upload
            class="upload-demo"
            :action="apiUrl"
            :show-file-list="false"
            accept=".mp4"
            :on-success="handleVideoSuccess"
            :before-upload="beforeUploadVideo"
            :on-progress="uploadVideoProcess"
          >
            <video
              v-if="this.videoList != '' && !videoFlag"
              :src="this.videoList"
              class="avatar video-avatar"
              controls="controls"
            >
              您的浏览器不支持视频播放
            </video>

            <i
              v-else-if="this.videoList == '' && !videoFlag"
              class="el-icon-plus avatar-uploader-icon"
            ></i>

            <el-progress
              v-if="videoFlag == true"
              type="circle"
              :percentage="videoUploadPercent"
              style="margin-top:30px;"
            ></el-progress>
          </el-upload>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false"
            >确 定</el-button
          >
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>
    <div class="tinymce-container">
      <div class="mce-tinymce mce-container mce-panel">
        <Editor
          :id="editorId"
          v-model="editorValue"
          :init="editorInit"
        ></Editor>
      </div>

      <div class="editor-custom-btn-container">
        <el-button class="el-icon-plus" @click="dialogFormVisible = true"
          >上传视频</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfDialog from "@/components/controls/of_dialog/of_dialog";

// 引入组件
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/icons/default/icons";
import "tinymce/themes/silver";
// 引入富文本编辑器主题的js和css
import "tinymce/themes/silver/theme.min";
import "tinymce/skins/ui/oxide/skin.min.css";
// 扩展插件
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount"; // 字数统计插件
//import 'tinymce/plugins/media';// 插入视频插件
import "tinymce/plugins/template"; // 模板插件
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/paste";
import "tinymce/plugins/preview";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/textcolor";
import "../../../assets/tinymce/plugins/lineheight";
import "@/assets/tinymce/plugins/indent2em";

export default {
  name: "TinymceEditor",
  components: { OfUpload, Editor, OfDialog },
  props: {
    height: {
      type: Number,
      default: 500
    },
    id: {
      type: String,
      default: "tinymceEditor"
    },
    value: {
      type: String,
      default: ""
    },
    plugins: {
      type: [String, Array],
      default:
        //"lineheight"
        "link lists image code wordcount fullscreen preview paste contextmenu textcolor lineheight indent2em"
    },
    toolbar: {
      type: [String, Array],
      default:
        //"lineheightselect"
        "preview | indent2em | undo redo | alignleft aligncenter alignright alignjustify lineheight | outdent indent blockquote |  bullist numlist |  bold italic underline strikethrough  | forecolor backcolor  | fontselect | fontsizeselect | link unlink image  | removeformat"
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editorInit: {
        paste_auto_cleanup_on_paste : false,
        paste_remove_styles: false,
        paste_remove_styles_if_webkit: false,
        paste_strip_class_attributes: false,
        language_url: "tinymce/langs/zh_CN.js",
        language: "zh_CN",
        skin_url: "tinymce/skins/ui/oxide",
        content_css: "tinymce/skins/content/default/content.css",
        height: this.height,
        content_style:
          "* { padding:0; margin:0; } img {max-width:100% !important }",
        plugin_preview_width: 375, // 预览宽度
        plugin_preview_height: 668,
        // lineheight_formats:
        //   "1 1.1 1.2 1.3 1.35 1.4 1.5 1.55 1.6 1.75 1.8 1.9 1.95 2 2.1 2.2 2.3 2.4 2.5 2.6 2.7 2.8 3 3.1 3.2 3.3 3.4 4 5",
        fontsize_formats:
          "8pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 24pt 36pt",
        font_formats:
          "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        powerpaste_word_import: "merge",
        plugins: this.plugins,
        toolbar: this.toolbar,
        toolbar_mode:"wrap",
        paste_data_images: true,
        statusbar: true, // 底部的状态栏
        menubar: true, // 最上方的菜单
        branding: false, // 水印“Powered by TinyMCE”
        convert_urls:false,
        //图片上传
        images_upload_handler: function(blobInfo, succFun, failFun) {
          var xhr, formData;
          var file = blobInfo.blob(); //转化为易于理解的file对象
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open("POST", "/api/File/FileUpload");
          xhr.onload = function() {
            let json;
            if (xhr.status != 200) {
              failFun("HTTP Error: " + xhr.status);
              return;
            }
            json = JSON.parse(xhr.response);
            if (!json) {
              failFun("Invalid JSON: " + xhr.responseText);
              return;
            }
            succFun(process.env.VUE_APP_HOME_URL + '/files' + json.Data.StorePath);
          };
          formData = new FormData();
          formData.append("file", file, file.name); //此处与源文档不一样
          xhr.send(formData);
        }
      },
      // apiUrl: "/api/File/FileUpload",
      apiUrl: "/api/File/FileUpload",
      editorId: this.id,
      newValue: "",
      pictureList: [],
      showFileList: false,
      activeName: "second",
      formTitle: "",
      dialogVisible: false,
      dialogFormVisible: false,
      videoFlag: false, //是否显示进度条
      videoUploadPercent: "", //进度条的进度，
      isShowUploadVideo: false, //显示上传按钮
      videoList: "",
      pyhi: "",
      pyhiw: "",
      pyhih: "",
      homeUrl: process.env.VUE_APP_HOME_URL
    };
  },
  watch: {
    newValue(newValue) {
      this.$emit("input", newValue);
    }
  },
  mounted() {
    tinymce.init({
      selector: '#tinydemo',
      plugins: "code indent2em",
      toolbar: "code indent2em",
    });
    this.setModel();
  },
  computed: {
    editorValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.newValue = val;
      }
    }
  },
  methods: {
    clear() {
      this.editorValue = "";
    },
    iframepyhi() {
      window.tinyMCE.get(this.editorId).insertContent(this.pyhi);
      this.dialogFormVisible = false;
    },
    onUpLoad(file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      if (file.response.Code === 0) {
        window.tinyMCE.get(this.editorId).insertContent(
          `<p>
                            <span class="mce-preview-object mce-object-video" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src=${file.response.Data.DownloadUrl} data-mce-html="%20">
                                <video src=${process.env.VUE_APP_HOME_URL + file.response.Data} width="420px" controls="controls"></video>
                            </span>
                         </p>`
          //`<iframe src="//player.bilibili.com/player.html?aid=371519340&amp;bvid=BV1rZ4y1T7Fa&amp;cid=219407186&amp;page=1" frameborder="no" scrolling="no" allowfullscreen="allowfullscreen">
          //</iframe>`
        );
        this.$message({
          message: "上传成功",
          type: "success"
        });
      }
    },
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 100;
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov"
        ].indexOf(file.type) == -1
      ) {
        this.$message({
          message: "请上传正确的视频格式",
          type: "error"
        });
        return false;
      }
      if (fileSize == false) {
        this.$message({
          message: "视频大小不能超过100MB",
          type: "error"
        });
        return false;
      }
      this.isShowUploadVideo = false;
    },
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      if (res.Code == 0) {
        window.tinyMCE.get(this.editorId).insertContent(
          `<p>
                            <span class="mce-preview-object mce-object-video" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src=${file.response.Data.DownloadUrl} data-mce-html="%20">
                                <video src=${process.env.VUE_APP_HOME_URL + '/files' + file.response.Data.StorePath} width="420px" controls="controls"></video>
                            </span>
                      </p>`
        );
        this.dialogFormVisible = false;
        //this.videoList = res.Data.DownloadUrl
      } else {
        this.$message.error("视频上传失败，请重新上传！");
      }
    },
    setModel() {
      if (this.isEdit) {
        tinymce.editors["tinymceEditor"].setMode("readonly"); //开启只读模式
      } else {
        tinymce.editors["tinymceEditor"].setMode("design"); //开启编辑模式
      }
    }
  }
};
</script>
<style scoped>
.editor-custom-btn-container {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 1300000;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.video-avatar {
  width: 400px;
  height: 200px;
}
.tinymce-container >>> .tox-toolbar__group {
  border-bottom: 1px solid #CCCCCC;
}
/* .tinymce-container >>> .tox-toolbar{
  width: 85%;
} */
/*p { text-indent:2em; }*/
</style>
